import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useSiteContent } from "../../hooks/useSiteContent";

export default function Hero() {
  const { content } = useSiteContent();
  return (
    <section id="top" className="relative min-h-screen flex items-center overflow-hidden hero-bg grain" data-testid="hero-section">
      <div className="container relative z-10 pt-32 pb-20 lg:py-0 lg:min-h-screen lg:flex lg:items-center">
        <div className="grid lg:grid-cols-[1.15fr_1fr] gap-14 lg:gap-20 items-center w-full">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }}>
            <h1 className="text-[34px] leading-[1.05] md:text-5xl lg:text-6xl font-display font-light tracking-tight mb-8">
              {content.hero_title_line1}<br />
              <span className="italic font-normal text-gold-gradient">{content.hero_title_line2}</span>
            </h1>
            <p className="text-lg text-muted-foreground max-w-xl mb-10 leading-relaxed">
              {content.hero_subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a href="#contato" data-testid="hero-cta-primary" className="group inline-flex items-center justify-center gap-3 px-7 py-4 rounded-full text-primary-foreground font-medium shadow-gold transition-all hover:translate-y-[-1px]" style={{ background: "var(--gold-gradient)" }}>
                {content.hero_cta_text}
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
            <div className="flex items-center gap-6 text-xs text-muted-foreground">
              <div className="flex items-center gap-2"><ShieldCheck size={16} className="text-primary" /> {content.hero_badge_text}</div>
              <div className="hidden sm:flex items-center gap-2"><span className="w-1 h-1 rounded-full bg-primary" />R$ 13M+ em carteira</div>
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1, delay: 0.3 }} className="relative flex justify-center lg:justify-end">
            <div className="absolute -inset-10 blur-[80px] opacity-30 rounded-full" style={{ background: "var(--gold-gradient)" }} />
            <div className="relative">
              <img src="/images/juliano-wagner.png" alt="Juliano Wagner" className="relative w-[360px] md:w-[440px] h-auto rounded-sm border border-primary/20 grayscale-[0.15] contrast-[1.05]" data-testid="hero-portrait" />
              <div className="absolute -bottom-5 -right-5 bg-card-gradient border border-primary/40 px-5 py-3 rounded-sm shadow-gold">
                <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Credenciado</div>
                <div className="font-display text-lg text-gold-gradient">ANCORD · Ademicon NH</div>
              </div>
              <div className="absolute -top-5 -right-5 bg-background/60 backdrop-blur-md border border-border px-4 py-3 rounded-sm">
                <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Carteira</div>
                <div className="font-display text-xl">{content.hero_portfolio_value}<span className="text-primary">+</span></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
